import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '@/features/workspace/settings-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/settings')({
  component: SettingsRoute,
})

function SettingsRoute() {
  const { workspaceSlug } = Route.useParams()

  return <SettingsPage workspaceSlug={workspaceSlug} />
}
